import React from 'react';
import { HelpCircle } from 'lucide-react';
import { faqData } from '../mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  return (
    <section id="faq" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <HelpCircle className="text-[#C5A572]" size={40} />
            <h2 className="text-4xl md:text-5xl font-bold text-[#8B9E8A]">
              Questions Fréquentes
            </h2>
          </div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tout ce que vous devez savoir sur le massage animalier
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border border-[#C5A572]/20 rounded-lg px-6 bg-white shadow-sm hover:shadow-md transition-shadow"
              >
                <AccordionTrigger className="text-left text-[#8B9E8A] font-semibold text-lg hover:text-[#C5A572] transition-colors py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pt-2 pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* CTA */}
          <div className="mt-12 text-center bg-gradient-to-r from-[#8B9E8A] to-[#9CAF88] text-white rounded-2xl p-8">
            <h3 className="text-2xl font-bold mb-3">Une autre question ?</h3>
            <p className="mb-6 text-white/90">
              N'hésitez pas à me contacter, je serai ravie de vous répondre !
            </p>
            <a
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                const element = document.getElementById('contact');
                if (element) {
                  const offset = 80;
                  const elementPosition = element.getBoundingClientRect().top;
                  const offsetPosition = elementPosition + window.pageYOffset - offset;
                  window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                  });
                }
              }}
              className="inline-block bg-gradient-to-r from-[#C5A572] to-[#B8860B] text-white px-8 py-3 rounded-full font-bold hover:shadow-xl transition-all duration-300 hover:scale-105"
            >
              Contactez-moi
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
